const API_BASE = "/api";

// Set by App.jsx so api.js can trigger logout when refresh fails
let _logoutHandler = null;
export function setLogoutHandler(fn) { _logoutHandler = fn; }

async function tryRefresh() {
  const refreshToken = localStorage.getItem("ft_refresh");
  if (!refreshToken) return false;
  try {
    const res = await fetch(API_BASE + "/auth/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken }),
    });
    if (!res.ok) return false;
    const data = await res.json();
    localStorage.setItem("ft_token", data.token);
    localStorage.setItem("ft_refresh", data.refreshToken);
    return true;
  } catch {
    return false;
  }
}

async function _fetch(path, options = {}) {
  const token = localStorage.getItem("ft_token");
  const res = await fetch(API_BASE + path, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  return res;
}

export async function apiFetch(path, options = {}) {
  let res;
  try {
    res = await _fetch(path, options);
  } catch {
    throw Object.assign(new Error("Network error"), { error: "Network error" });
  }

  // On 401, attempt a silent token refresh then retry once
  if (res.status === 401 && path !== "/auth/refresh") {
    const refreshed = await tryRefresh();
    if (refreshed) {
      try {
        res = await _fetch(path, options);
      } catch {
        throw Object.assign(new Error("Network error"), { error: "Network error" });
      }
    } else {
      if (_logoutHandler) _logoutHandler();
      throw Object.assign(new Error("Session expired"), { error: "Session expired" });
    }
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: "Network error" }));
    // FastAPI uses `detail`, normalize to `error` so callers can check either
    if (err.detail && !err.error) err.error = err.detail;
    throw err;
  }
  return res.json();
}
